import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { Box, CircularProgress, Typography } from "@mui/material";

function DrawerActionItem({ sx = [], ...props }) {
  const { title, icon, onClick = () => {}, loading } = props;
  const Icon = icon;
  return (
    <Box
      onClick={!loading && onClick}
      sx={[
        {
          p: "8px",
          width: "100%",
          display: "flex",
          alignItems: "center",
          borderRadius: "8px",
          border: (theme) => `1px solid ${theme.palette.grey[6]}`,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Icon width={24} height={24} />
      <Typography variant="body1" color={loading ? "grey.4" : "grey.2"} ml={2}>
        {title}
      </Typography>
      {loading && (
        <CircularProgress size={"16px"} sx={{ ml: 2, color: "primary.main" }} />
      )}
    </Box>
  );
}

export default DrawerActionItem;
